/* eslint-disable no-undef */
import { getToken } from '@/utils/auth';
import useWPClient from '@/composables/services/useWPClient';
export const useAuthStore = defineStore('authStore', () => {
  const WPClient = useWPClient();
  const token = ref('');
  const user = ref({});
  const isUser = computed(() => !!token.value);
  const validateToken = async token => {
    try {
      return await WPClient.validateToken(token);
    } catch (error) {
      return false;
    }
  };
  const authInit = async () => {
    const token = getToken();
    const isTokenValid = await validateToken(token);

    // Check if token is still valid
    if (token && isTokenValid) {
      setToken(token);
    } else {
      console.log('authInit: User is not logged in.');
    }
  };
  const setToken = newValue => token.value = newValue;
  const clearToken = () => token.value = '';
  const setUser = newValue => user.value = newValue;
  const clearUser = () => user.value = {};
  const setTokenToCookie = token => document.cookie = `jwt_token=${token}; path=/`;
  return {
    token,
    user,
    isUser,
    authInit,
    setToken,
    clearToken,
    setUser,
    clearUser,
    setTokenToCookie
  };
});